import { Injectable } from "@angular/core";
import { CsMenuComponent } from "components/cs-menu/cs-menu";

@Injectable()
export class MenuController {
  menuComponent: CsMenuComponent = undefined;

  constructor() {

  }

  public registerHost(host: CsMenuComponent) {
    this.menuComponent = host;
  }

  enable(enable: boolean) {
    this.menuComponent.enable(enable);
  }

  async close() {
    return this.menuComponent.close();
  }

  async open() {
    return this.menuComponent.open();
  }

  isOpen(): boolean {
    return this.menuComponent.isOpen();
  }

  async waitMenuTransitions() {
    await this.menuComponent.waitMenuTransitions();
  }

}
